import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

export const fetchSalesRegisterList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getall`, {
    params: { UserId: userId, IsForDropodown: '0' }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchSalesRegisterById = async ({ salesRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getbyid`, {
    params: { SalesRegisterId: salesRegisterId }
  });
  return response?.data?.data ?? { header: null, details: [] };
};

export const saveSalesRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/save`, payload);
  return response?.data;
};

export const deleteSalesRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/delete`, payload);
  return response?.data;
};
